// extracted by mini-css-extract-plugin
module.exports = {"h1":"global_h1__VSlTE","h2":"global_h2__2gUs0","h2Subtitle":"global_h2Subtitle__1WQ7q","bodyText1":"global_bodyText1__29rBc","bodyText2":"global_bodyText2__gUIjg"};